import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import DropList from 'components/atoms/DropList';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Label from 'components/atoms/Label';
import { bindActionCreators, Dispatch } from 'redux';
import { portList } from 'services/ports';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { PortType, RootState } from 'types';
import { ActionsType } from 'types/system';
import { renderError, setKey } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface UserPortFilterModelProps {
    children?: string | JSX.Element | JSX.Element[];
    language: string;
    id?: string;
    data: any;
    actions: ActionsType | undefined;
    setErrorHandlerAction: SetErrorHandlerAction;
}

interface UserPortFilterModelState {
    errors: any;
    data: any | null;
    loading: boolean;
    filter: {
        port_id: any;
    };
    ports: PortType[];
}

class UserPortFilterModel extends Component<UserPortFilterModelProps, UserPortFilterModelState> {
    constructor(props: UserPortFilterModelProps) {
        super(props);
        this.state = {
            ports: [],
            data: null,
            loading: false,
            errors: {},
            filter: props.data.filter,
        };
    }

    componentDidMount(): void {
        this.getData();
    }

    handleChange = (name: string, value: unknown) => {
        const { filter, errors } = this.state;
        setKey(filter, name, value);
        setKey(errors, name, null);
        this.setState({ filter, errors });
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onConfirm(this.state.filter);
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    clearFilter = () => {
        this.props.actions?.onConfirm({ omc_user: true });
        this.props.actions?.onCancel();
    };

    getData = () => {
        portList()
            .then((res) => {
                this.setState({
                    ports: res.items,
                });
            })
            .catch((error) => {
                this.props.setErrorHandlerAction(error);
            });
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('User filter')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <FormGroup comments={renderError(this.state.errors?.['port_id'])} required={false}>
                        <Label>{translate('port')}</Label>
                        <DropList
                            capitalize
                            name="port_id"
                            id="port_id"
                            placeholder={translate('Select port')}
                            value={this.state.filter.port_id}
                            options={this.state.ports
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((x) => {
                                    return { value: x.id, label: x.name };
                                })}
                            onChange={this.handleChange}
                        ></DropList>
                    </FormGroup>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                type="button"
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button type="button" className="px-4 py-1 font-bold" onClick={this.clearFilter}>
                                {translate('Clear filter')}
                            </Button>
                            <Button
                                disabled={this.state.loading}
                                loading={this.state.loading}
                                type="submit"
                                className="px-4 py-2 bg-primary-submit rounded-md text-white"
                            >
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const userPortFilterModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    port: state.port.port,
    openModelFunction: state.layout.openModelFunction,
});

const userPortFilterModelDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(userPortFilterModelStateToProps, userPortFilterModelDispatchToProps)(UserPortFilterModel);
